/* istanbul ignore file */
const theme = ({
  palette: {
    primary: { normal },
    secondary: { normal: secondaryNormal },
    text: { light }
  }
}) => ({
  border: `1px solid ${secondaryNormal}`,
  background: light,
  startColor: normal
});

export const styles = ({
  datePickerDropDown,
  palette: {
    common: { black }
  },
  spacing: { unit }
}) => ({
  dropDown: {
    background: datePickerDropDown.background,
    border: datePickerDropDown.border,
    position: 'relative',
    borderRadius: 3,
    left: 0,
    padding: 0,
    margin: '-1px 0 0 0',
    zIndex: 200,
    '& ul': {
      padding: `${unit}px 0 0 ${unit * 2}px`
    },
    '& li': {
      listStyle: 'none'
    },
    '& li button': {
      alignItems: 'center',
      border: 'none',
      background: 'none',
      padding: 0,
      width: '100%',
      textAlign: 'left'
    },
    '& li.datepicker': {
      cursor: 'pointer',
      width: '100%'
    },
    '& span.icon-calendar': {
      display: 'none'
    },
    '& span.icon-wrapper, & span.help-block': {
      display: 'none'
    },
    '& $selection.form-control': {
      border: 'none',
      boxShadow: 'none',
      padding: 0,
      height: '100%'
    },
    '& $hiddenInput': {
      '& .datepicker': {
        display: 'block'
      },
      '& .form-control': {
        border: 'none',
        height: 0,
        minHeight: 0,
        padding: 0,
        width: 0
      }
    }
  },
  arrow: {
    margin: `0 ${unit}px ${unit / 4}px 0`,
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      height: unit * 1.5,
      stroke: black,
      width: unit * 1.5
    }
  },
  hiddenInput: {},
  selection: {
    cursor: 'pointer',
    display: 'flex'
  },
  start: {
    color: datePickerDropDown.startColor,
    margin: '0 auto 0 0'
  },
  toggleTrigger: {
    display: 'inline-block',
    width: `calc(100% - ${unit * 2.5}px)`,
    paddingRight: unit / 2
  },
  wrapper: {
    '& .icon-calendar': {
      float: 'right'
    }
  }
});

export default theme;
